import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { buildAgentTabCommands, tabEventRoutePath } from '../routing/browser-tab-routes';
import { BrowserTabService } from './browser-tab.service';
import { CROSS_APP_BRIDGE } from './cross-app-bridge';
import type { CrossAppBridgeEvent } from './cross-app-bridge';

/**
 * Applies Resolve → EventQ workspace events.
 * Transport is injected — MockCrossAppBridge today, BroadcastChannel later.
 */
@Injectable({ providedIn: 'root' })
export class CrossAppWorkspaceSyncService {
  private readonly bridge = inject(CROSS_APP_BRIDGE);
  private readonly browserTabs = inject(BrowserTabService);
  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    this.bridge.events$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((event) => {
      void this.handleEvent(event);
    });
  }

  private async handleEvent(event: CrossAppBridgeEvent): Promise<void> {
    if (event.type !== 'workspace.open' || !event.eventId) {
      return;
    }

    const tabId = this.browserTabs.activeTabId();
    this.browserTabs.updateTabRoutePath(tabId, tabEventRoutePath(event.eventId));
    await this.router.navigate(buildAgentTabCommands(tabId, tabEventRoutePath(event.eventId)));
  }
}
